import { axios } from '@/utils/request'

export function getSearchData (parameter) {
    return axios({
        url: '/search/',
        method: 'get',
        params: parameter
    })
}
